// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { createSelector } from 'reselect';

export const statusSelector = createSelector(
    (state: any) => state.actionStatus,
    actionStatus => (action: string) => actionStatus[action] || {}
);
export const countryListSelector = createSelector(
    (state: any) => state.countries,
    res => res.list
);
